export default __webpack_public_path__ + "static/media/Staking.1284528e.svg";